import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";
import Admin from "./Admin";
import Auth from "./Auth";
import Billing from "./Billing";
import Client from "./Client";
import Commodity from "./Commodity";
import Common from "./Common";
import Dispatch from "./Dispatch";
import Facility from "./Facility";
import FileManagementReducer from "./FileManagement";
import { EIDFormReducer, ViralLoadFormReducer } from "./HIV";
import NonConformity from "./NonConformity";
import Order from "./Order";
import Report from "./Report";
import Result from "./Result";
import Settings from "./Settings";
import TB from "./TB";
import esDashboardReducer from "./Espn";


const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    common: Common,
    auth: Auth,
    facility: Facility,
    admin: Admin,
    client: Client,
    tb: TB,
    vl: ViralLoadFormReducer,
    eid: EIDFormReducer,
    order: Order,
    result: Result,
    billing: Billing,
    report: Report,
    commodity: Commodity,
    dispatch: Dispatch,
    nonConformity: NonConformity,
    FileManagement: FileManagementReducer,
    esDashboard: esDashboardReducer, 
  });

export default createRootReducer;
